import { CatalogItemInOrder } from '../model/types/CatalogItemSchema';

export const mapCatalogItemFromOrder = (
    item: CatalogItemInOrder | null | undefined,
) => {
    if (!item?.itemInfoFrozen) {
        return null;
    }

    // We should really NEVER use this lowest proposal price anywhere
    // We should always be using the selected proposals and those prices
    // Some areas where it is used is in the property catalog...
    // BUT! We don't show prices there with that feature flag turned off now
    // That is the one spot proposals instead of customer specific selected proposals may be okay
    const lowestProposalPrice = item.proposals?.reduce((acc, proposal) => {
        return Math.min(acc, proposal.sellPrice);
    }, Infinity);

    return {
        selection: {
            qty: item.qty,
            orderItemId: item.id,
            uuid: item.itemInfoFrozen.uuid,
            catalogItemId: item.catalogItemId,
        },
        info: {
            ...item.itemInfoFrozen,
            categoryId: item.item?.categoryId ?? item.itemInfoFrozen.categoryId,
            isAddedToCatalog: item.item?.isAddedToCatalog,
            catalogItemId: item.item?.id,
            price: lowestProposalPrice || null,
            id: item.id,
            proposals: item?.proposals,
            selectedProposals: item.selectedProposals,
            replacedWith: item?.replacedWith,
            isCheckFinished: item?.isCheckFinished,
            isSourcingOverridden: item?.isSourcingOverridden,
        },
    };
};
